import { useTranslation } from "react-i18next";
import { ErrorPageProps } from "shared/components/empty/ErrorPageProps";
import { ErrorPageView } from "shared/components/empty/ErrorPageView";

export const GenericErrorPageView: React.FC<ErrorPageProps> = (props) => {
  const { t } = useTranslation(["common", "auth"]);
  return <ErrorPageView title={t("common:error.generic")} {...props} />;
};
